import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const useTeacherPacedModeOptInMutation = ({ stafferPath } : { stafferPath : string }) => (
  useMutation({
    mutationFn: ({ nextSetting }: { nextSetting: boolean }) => (
      axios
        .patch(stafferPath, { teacher_paced_mode: nextSetting })
        .then(res => res.data)
    ),
    mutationKey: ['useTeacherPacedModeOptInMutation'],
  })
);

export default useTeacherPacedModeOptInMutation;
